import { format } from 'date-fns'

// Día de un tour como texto 'yyyy-MM-dd', que es lo que el backend guarda (columna date).
// Un Date elegido en el calendario es medianoche LOCAL; mandarlo tal cual lo convierte a hora
// universal (toISOString) y en zonas por delante de UTC cae en el día anterior: un aliado en
// Alemania elegía el 12/10 y quedaba el 11/10 (caso real Kunti Travel, 06/10/2026). Por eso se
// toma el día con la hora local, y un texto que ya trae la fecha se deja con sus 10 primeros caracteres.
export function toDayString(d: Date | string): string {
    if (typeof d === 'string') return d.slice(0, 10)
    return format(d, 'yyyy-MM-dd')
}
